<p-toast></p-toast>

<div class="fadein animation-duration-200">
  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <div class="grid mt-4">
    <div class="col-12 lg:col-6">
      <app-page-data-panel title="POSM Tasks" subtitle="Store execution tasks that can be released to truck planning" [resultText]="tasks().length + ' total'">
        <div class="grid mb-3">
          <div class="col-12 md:col-7">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select inputId="posmTaskStore" [options]="storeOptions()" [(ngModel)]="taskDraft.storeId" appendTo="body" styleClass="w-full"></p-select>
                <label for="posmTaskStore">Target Store</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="col-12 md:col-5">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-list-check"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select inputId="posmTaskType" [options]="taskTypeOptions()" [(ngModel)]="taskDraft.taskType" appendTo="body" styleClass="w-full"></p-select>
                <label for="posmTaskType">Task Type</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
        </div>

        <p-table [value]="tasks()" [loading]="loading()" styleClass="p-datatable-sm no-borders">
          <ng-template pTemplate="header">
            <tr>
              <th>Task</th>
              <th>Store</th>
              <th>Status</th>
              <th>Transport</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-task>
            <tr>
              <td>
                <div class="font-bold text-900">{{ task.taskType || '-' }}</div>
                <div class="text-sm text-500 mt-1">Task #{{ task.id || '-' }}</div>
              </td>
              <td>{{ storeName(task) }}</td>
              <td><p-tag [value]="task.status || 'PENDING'" [severity]="statusSeverity(task.status)"></p-tag></td>
              <td>
                <p-tag [value]="task.transportStatus || 'NOT_RELEASED'" [severity]="transportSeverity(task.transportStatus)"></p-tag>
                @if (task.deliveryId) {
                  <div class="text-xs text-500 mt-1">Delivery #{{ task.deliveryId }}</div>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="4" class="text-center p-4 text-500">No POSM store execution tasks linked to this project.</td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>

    <div class="col-12 lg:col-6">
      <app-page-data-panel title="POSM Incidents" subtitle="Client and execution issues linked to this project" [resultText]="incidents().length + ' total'">
        <div class="grid mb-3">
          <div class="col-12 md:col-5">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-exclamation-triangle"></i></p-inputGroupAddon>
              <p-iftalabel>
                <input id="posmIncidentTitle" pInputText [(ngModel)]="incidentDraft.title" class="w-full">
                <label for="posmIncidentTitle">Incident Title</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="col-12 md:col-4">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-tags"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select inputId="posmIncidentCategory" [options]="incidentCategoryOptions()" [(ngModel)]="incidentDraft.category" appendTo="body" styleClass="w-full"></p-select>
                <label for="posmIncidentCategory">Category</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="col-12 md:col-3">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-bolt"></i></p-inputGroupAddon>
              <p-iftalabel>
                <p-select inputId="posmIncidentSeverity" [options]="severityOptions()" [(ngModel)]="incidentDraft.severity" appendTo="body" styleClass="w-full"></p-select>
                <label for="posmIncidentSeverity">Severity</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
          <div class="col-12">
            <p-inputGroup>
              <p-inputGroupAddon><i class="pi pi-align-left"></i></p-inputGroupAddon>
              <p-iftalabel>
                <textarea id="posmIncidentDescription" pTextarea rows="2" [(ngModel)]="incidentDraft.description" class="w-full"></textarea>
                <label for="posmIncidentDescription">Incident Description</label>
              </p-iftalabel>
            </p-inputGroup>
          </div>
        </div>

        <p-table [value]="incidents()" [loading]="loading()" styleClass="p-datatable-sm no-borders">
          <ng-template pTemplate="header">
            <tr>
              <th>Incident</th>
              <th>Category</th>
              <th>Status</th>
              <th>Severity</th>
              <th class="text-right">Action</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-incident>
            <tr>
              <td>
                <div class="font-bold text-900">{{ incident.title }}</div>
                @if (incident.description) {
                  <div class="text-sm text-500 mt-1">{{ incident.description }}</div>
                }
              </td>
              <td>{{ incident.category || '-' }}</td>
              <td><p-tag [value]="incident.status || 'OPEN'" [severity]="incidentStatusSeverity(incident.status)"></p-tag></td>
              <td><p-tag [value]="incident.severity || 'MEDIUM'" [severity]="incidentSeverity(incident.severity)"></p-tag></td>
              <td class="text-right">
                @if (incident.id && incidentStatusSeverity(incident.status) !== 'success') {
                  <p-button label="Resolve" icon="pi pi-check" severity="success" [outlined]="true" (click)="resolveIncident(incident)"></p-button>
                } @else {
                  <span class="text-500">-</span>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="5" class="text-center p-4 text-500">No POSM incidents linked to this project.</td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </div>
  </div>
</div>
